export default "__VITE_ASSET__0563fc2b__"